import { inject, signal, DestroyRef, Service } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Api } from '@api/api';
import { getCategoriesTree, getCategoryCategory } from '@api/functions';
import type { CategoryTreeItemDto } from '@api/models';
import { onWindowLoad } from '../../helpers/on-window-load.function';

@Service()
export class CategoryService {
  private api = inject(Api);
  private destroyRef = inject(DestroyRef);

  categories = signal<CategoryTreeItemDto[]>([]);

  constructor() {
    this.setCategories();

    onWindowLoad(() => this.setCategories());
  }

  setCategories() {
    this.api.invoke(getCategoriesTree)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: response => {
          this.categories.set(response.data);
        },
        error: err => {
          console.warn(`${new Date().toISOString()} - Could not set categories`, err.message);
        }
      });
  }

  fetchCategory(slug: string) {
    return this.api.invoke(getCategoryCategory, { slug });
  }
}
